import * as React from "react"
import Button from "../Button/Button"
import { ContactStyles } from "./ContactStyles"

const Contact = () => {
  return (
    <ContactStyles className="section">
      <form
        name="contact"
        method="POST"
        action="/thank-you/"
        data-netlify="true"
        netlify-honeypot="bot-field"
      >
        <input type="hidden" name="form-name" value="contact" />
        <p className="hidden-field">
          <label>
            Don’t fill this out if you’re human: <input name="bot-field" />
          </label>
        </p>

        <label className="field">
          <span className="field__label">Name</span>
          <input placeholder="Your name…" type="text" name="name" required />
        </label>

        <label className="field">
          <span className="field__label">Email</span>
          <input placeholder="you@email.com" type="email" name="email" required />
        </label>

        <label className="field">
          <span className="field__label">Project</span>
          <textarea
            placeholder="Tell us a little about you and your project…"
            name="message"
            rows="6"
            required
          ></textarea>
        </label>

        <Button text="Send Message" arrow />
      </form>
    </ContactStyles>
  )
}

export default Contact
